import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';


import {UserAccountComponent} from './user-account.component';
import {MyOrdersComponent} from './my-orders/my-orders.component';
import {MySubscriptionsComponent} from './my-subscriptions/my-subscriptions.component';
import {OrderDetailModule} from '@app/ui-order-detail';
import {RouterModule, Routes} from '@angular/router';
import {SubscriptionListComponent} from "@app/feature-subscription";
import { UiMiniCartModule } from '@app/ui-cart';

const routes: Routes = [
  {
    path: '', children: [
      {path: '', redirectTo: 'orders', pathMatch: 'full'},
      {
        path: 'orders',
        component: MyOrdersComponent,
      },
      {path: 'subscriptions', component: MySubscriptionsComponent},
    ], component: UserAccountComponent
  }
];

@NgModule({
  declarations: [UserAccountComponent, MyOrdersComponent, MySubscriptionsComponent],
  imports: [
    RouterModule.forChild(routes),
    SubscriptionListComponent,
    CommonModule,
    OrderDetailModule,
    UiMiniCartModule
  ],
  bootstrap: [UserAccountComponent],
  exports: [RouterModule],
})
export class UserAccountModule {
}
